import './R2SectionComponent.css';
import ambulanceRed from '../Images/ambulance_red.png';

const R2SectionComponent = (props) => {
    return <div className="viewport grid-parent r2-layout" id="r2">
        <div className="r-box">R</div>
        <div className="two-box">2</div>
        <div className="route-div">Route Reservation Engine</div>
    
        <span className="temporary-span">Temporary open passage corridors</span>
        <span className="emergency-span">for emergency vehicles</span>

        <div className="corridor"></div>
        <div id="animated-designation" className="designation-box">#4TA7</div>
        <img id="animated-ambulance" src={ambulanceRed} alt="Ambulance truck with red cross" />

        <div className="algebra-box">
            <button className="bigger-picture-btn" onClick={props.modalClick}>
                See the Bigger Picture
            </button>
        </div>
    </div>
};

export default R2SectionComponent;